import { FieldValue, QueryRule } from '../../../../../types/QueryBuilder';
import { useLanguage } from '../../../../../context/LanguageContext';

export type Translate = ReturnType<typeof useLanguage>['t'];

export const normalizeForSearch = (value: string): string =>
    value.trim().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');

export function filterByLabel(values: FieldValue[], search: string): FieldValue[] {
    const query = normalizeForSearch(search);
    return query ? values.filter(option => normalizeForSearch(option.label).includes(query)) : values;
}

export function setSelected(selected: string[], names: string[], checked: boolean): string[] {
    if (checked) {
        const current = new Set(selected);
        return [...selected, ...names.filter(name => !current.has(name))];
    }
    const removed = new Set(names);
    return selected.filter(name => !removed.has(name));
}

export const toStringList = (value: QueryRule['value']): string[] => {
    if (Array.isArray(value)) return value;
    if (value === null || value === undefined || value === '') return [];
    return [String(value)];
};

export const translateWithCount = (t: Translate, key: string, count: number): string =>
    t(key).replace('{count}', String(count));

export function parseSubscriptionSelections(entries: string[]): Map<string, string> {
    const selectionByName = new Map<string, string>();
    entries.forEach(entry => {
        const separatorIndex = entry.indexOf(':');
        if (separatorIndex !== -1) selectionByName.set(entry.slice(0, separatorIndex), entry.slice(separatorIndex + 1));
    });
    return selectionByName;
}

export const BORDERED_BOX_SX = {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    bgcolor: 'background.paper',
} as const;
